import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '@/hooks/useApi/useFetchCreditCardTransaction';
import { useBlockingLoader } from 'shared';
import { useToast } from '@/providers/Toast.provider';

type CreditCardTransactionContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof CreditCardTransactionInfo>, 'transaction'>;

export default function CreditCardTransactionContainer({
  TransactionID,
  isParent = false,
  jwt,
  eLinxRequestID = '',
  ...props
}: CreditCardTransactionContainerProps) {
  const blockingLoader = useBlockingLoader();
  const toast = useToast();

  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.TransactionHistory.Details.CreditCardTransactionInfo',
  });

  const { creditCardTransaction, fetchCreditCardTransaction } = useFetchCreditCardTransaction();

  useEffect(() => {
    blockingLoader.show();

    fetchCreditCardTransaction(TransactionID, jwt)
      .catch(() => toast.neutral(t('fetchingError', { defaultValue: 'Failed to fetch transaction details' })))
      .finally(() => blockingLoader.hide());
  }, [TransactionID, jwt]);

  return (
    <div>
      {creditCardTransaction && (
        <CreditCardTransactionInfo
          transaction={creditCardTransaction}
          isParent={isParent}
          jwt={jwt}
          eLinxRequestID={eLinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
